import { withTranslation } from "react-i18next";
import ContractInfo from './ContractInfo';

export default withTranslation()(ContractInfo);